var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
    'bto-sb-event-odd',
    {
      'bto-sb-odd-lock':
        (_vm.outcome.outcome === '--' && _vm.outcome.id > 0) ||
        _vm.outcome.active === false ||
        _vm.match.isBetStop ||
        _vm.checkSuspended(),
      'bto-sb-event-odd-active': _vm.checkOddActive() && !_vm.match.isBetStop,
    },
    _vm.getOutcomeChangeClass,
    _vm.quickBetClasses,
  ],on:{"click":function($event){$event.preventDefault();return _vm.processOdd()}}},[(_vm.getQuickBetNotification && _vm.getQuickBetNotification.betslip.status === 4)?_c('span',{staticClass:"bto-sb-spinner-v1"}):_vm._e(),_c('i',[_vm._v(_vm._s(_vm.label)+" "+_vm._s(_vm.outcome.id === 0 ? '' : _vm.outcome.sbv))]),_c('i',[_vm._v(_vm._s(_vm.formatedOutcome || "--"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }